export default __webpack_public_path__ + "static/media/armB.ec1b3045.png";